type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};
const TimelineShapeIcon = (props: Props) => {
  return (
    <svg
      width={props.width || '16'}
      height={props.width || '16'}
      viewBox={props.viewBox || '0 0 14 14'}
      fill="none"
    >
      <path
        d="M1.89342 13.0353H12.1077C12.6206 13.0353 13.0363 12.6196 13.0363 12.1067V1.89244C13.0363 1.3796 12.6206 0.963867 12.1077 0.963867H1.89342C1.38058 0.963867 0.964844 1.3796 0.964844 1.89244V12.1067C0.964844 12.6196 1.38058 13.0353 1.89342 13.0353Z"
        stroke={props.strokeColor || '#F2D093'}
      />
    </svg>
  );
};

export default TimelineShapeIcon;
